import { AxiosError } from "axios";
import { translate } from "./index";

export function Catch(handler?: HandlerFunction<any>) {
  return (_target: any, _key: string, descriptor: PropertyDescriptor) => {
    const method = descriptor.value;

    descriptor.value = async function(...args: any[]) {
      try {
        const result = await method(...args);
        return result;
      } catch (error) {
        if (!handler) return;

        return await handler(error, ...args);
      }
    };
  };
}

export function CatchSync(handler?: HandlerFunction<any>) {
  return (_target: any, _key: string, descriptor: PropertyDescriptor) => {
    const method = descriptor.value;

    descriptor.value = function(...args: any[]) {
      try {
        const result = method(...args);
        return result;
      } catch (error) {
        if (!handler) return;

        return handler(error, ...args);
      }
    };
  };
}

export const ApiCatch = Catch((e: AxiosError) => e.response);

/**
 * @description Decorator to return MessageValue
 */
export const ApiTranslate = Catch((e: AxiosError) => ({
  result: false,
  message: e.response ? translate(e.response.data.message).name : "",
}));
